import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UsersStore } from '@data-access/user/stores/users.store';
import { UserRole } from '@shared/interfacres/user';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate {
  private userStore = inject(UsersStore);
  private router = inject(Router);

  canActivate(): boolean {
    if (this.userStore.user() && this.userStore.user()?.role === UserRole.Admin) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;

  }
}
